import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'produto-do-plano',
    templateUrl: './produto-do-plano-card.component.html',
    styleUrls: ['./produto-do-plano-card.component.scss'],
    standalone: false
})
export class ProdutoDoPlanoCard {
  @Output('p-click') click = new EventEmitter<MouseEvent>();
  @Input('p-image') image: string;
  @Input('p-is-destacado') isDestacado: boolean = false; 
}